module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "btn--floating btn--flat"
  }, [_vm._v("TEST")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.customHTML)
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-select', {
    ref: "mySelect",
    attrs: {
      "items": _vm.items,
      "autocomplete": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5de4a65c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Test.vue
// module id = 372
// module chunks = 0